<template>
  <div class="value-font">
    <div v-text="urinaryTest" :data-test="dataTest" />
  </div>
</template>

<script>
import VueTypes from "vue-types";

export default {
  props: {
    value: VueTypes.number.isRequired,
    dataTest: VueTypes.string
  },
  computed: {
    urinaryTest() {
      switch (this.value) {
        case 1:
          return this.$i18n.t("bloodTestResult.negative");
        case 2:
          return this.$i18n.t("bloodTestResult.trace");
        case 3:
          return this.$i18n.t("bloodTestResult.+1");
        case 4:
          return this.$i18n.t("bloodTestResult.+2");
        case 5:
          return this.$i18n.t("bloodTestResult.+3");
        case 6:
          return this.$i18n.t("bloodTestResult.+4");
      }
    }
  }
};
</script>

<style scoped>
.value-font {
  font-weight: bold;
}
</style>
